import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  textColor?: string;
}

export const Root = styled.div`
  display: block;
  align-items: center;
  padding: 10.5px 30px;
`

export const InputNameFolder = styled.input`
  width: 100%;
  display: block;
  color: rgba(16, 16, 89, 0.6);
  border: unset;
  font-size: 18px;
  font-weight: normal;
  font-style: italic;
  box-shadow: unset;
  height: auto;
  padding: 0px;
  &:focus {
    outline:  none};
  }
  ::placeholder, ::-webkit-input-placeholder {
    color: rgba(16, 16, 89, 0.6);
  }
`

export const TipLabel = styled.div`
  display: block;
  bottom: 0px
  height: 14px;
  width: 100%;
  margin: 6px 0px 0px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : '#8891a0'};
`